import React, { useState } from 'react';
import { Badge, Container, Row } from 'reactstrap';
import moment from 'moment-timezone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import EditMissionControlVersionModal from '../../../../../Modals/MissionControl/EditMissionControlVersionModal';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../../context';

const MissionControlStatusDetails = (props) => {
    const { missionControlHeartbeat, targetManifestVersion, refreshManifest } =
        props;

    const dispatch = useDispatch();

    const instanceId = useSelector(
        (state) => state.practice?.practice?.instanceId
    );
    const [
        isEditMissionControlVersionModalOpen,
        setIsEditMissionControlVersionModalOpen,
    ] = useState(false);

    const GetStatusMessage = () => {
        if (
            missionControlHeartbeat === null ||
            missionControlHeartbeat === undefined
        ) {
            return 'Unable to retrieve heartbeat status';
        } else if (!missionControlHeartbeat.alive) {
            return `No heartbeat received since ${
                moment
                    .utc(missionControlHeartbeat.lastHeartbeat)
                    .local()
                    .format('M/D/YYYY LT') +
                ' ' +
                moment.tz(moment.tz.guess()).zoneAbbr()
            }`;
        } else if (missionControlHeartbeat.version !== targetManifestVersion) {
            return `Current and target Mission Control versions don't match`;
        } else {
            return 'Heartbeat received';
        }
    };

    const GetStatus = () => {
        if (
            missionControlHeartbeat === null ||
            missionControlHeartbeat === undefined ||
            missionControlHeartbeat.version !== targetManifestVersion ||
            !missionControlHeartbeat.alive
        ) {
            return <Badge color="danger">Abnormal</Badge>;
        }

        return <Badge color="success">Normal</Badge>;
    };

    const GetCurrentVersion = () => {
        if (
            missionControlHeartbeat === null ||
            missionControlHeartbeat === undefined
        ) {
            return 'Unable to retrieve heartbeat status';
        }

        if (missionControlHeartbeat.version === '0.0.0.0') {
            //Default value sent by Instance Support
            return 'Not found';
        }

        return missionControlHeartbeat.version;
    };

    const SaveEditMissionControlVersionBehavior = (
        selectedMissionControlVersion
    ) => {
        return dispatch(
            actions.clientPlugins.updateMissionControlVersion(
                instanceId,
                selectedMissionControlVersion
            )
        );
    };

    return (
        <>
            <EditMissionControlVersionModal
                isOpen={isEditMissionControlVersionModalOpen}
                closeBehavior={() =>
                    setIsEditMissionControlVersionModalOpen(false)
                }
                currentMissionControlVersion={targetManifestVersion}
                refreshBehavior={refreshManifest}
                saveBehavior={SaveEditMissionControlVersionBehavior}
            />
            <Container className="m-1">
                <Row>
                    <b>Mission Control Status:&nbsp;</b>
                    {GetStatus()}
                </Row>
                <Row>
                    <b>Status Message:&nbsp;</b>
                    {GetStatusMessage()}
                </Row>
                <Row>
                    <b>Current Version:&nbsp;</b>
                    {GetCurrentVersion()}
                </Row>
                <Row>
                    <b>Target Version:&nbsp;</b>
                    {targetManifestVersion}
                    {targetManifestVersion && (
                        <FontAwesomeIcon
                            icon={faEdit}
                            style={{ marginLeft: '10px' }}
                            onClick={() =>
                                setIsEditMissionControlVersionModalOpen(true)
                            }
                        />
                    )}
                </Row>
            </Container>
        </>
    );
};

export default MissionControlStatusDetails;
